<footer class="footer">
  <div class="footer-content">
    <p class="copyright text-muted m-0">
      Copyright &copy; {{currentDate | date: 'yyyy'}} Plataforma Census
      <span class="d-none d-sm-inline-block">, Todos direitos reservados.</span>
    </p>

    <button
      type="button"
      class="build-version"
      [class.build-version--outdated]="updateAvailable"
      (click)="openReleases(releasesModal)"
      [attr.aria-label]="'Ver novidades da versão ' + buildInfo.version"
      [title]="updateAvailable ? 'Nova versão disponível. Clique para ver.' : 'Clique para ver as novidades'">
      <span
        class="build-status"
        [class.build-status--checking]="checkingBuild"
        [class.build-status--outdated]="updateAvailable"
        [class.build-status--unavailable]="buildCheckUnavailable"
        aria-hidden="true"></span>
      v{{ buildInfo.version }} ({{ buildInfo.revision }})
      <span class="build-date">&middot; {{ buildInfo.builtAt | date: 'dd/MM/yyyy HH:mm' }}</span>
      <span
        *ngIf="!checkingBuild && !updateAvailable && !buildCheckUnavailable"
        class="current-label">Versão atual</span>
      <span *ngIf="updateAvailable" class="update-label">Atualização disponível</span>
      <span *ngIf="buildCheckUnavailable" class="unavailable-label">Não verificada</span>
    </button>
  </div>
</footer>

<ng-template #releasesModal let-modal>
  <div class="modal-header releases-header">
    <div>
      <h4 class="modal-title">Novidades da plataforma</h4>
      <p class="modal-subtitle mb-0">
        Versão em uso: {{ buildInfo.version }} ({{ buildInfo.revision }})
      </p>
    </div>
    <button type="button" class="close" aria-label="Fechar" (click)="modal.dismiss('close')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body releases-body">
    <div *ngIf="updateAvailable" class="update-warning" role="alert">
      <div>
        <strong>Existe uma versão mais nova disponível.</strong>
        <span> Atualize a página para limpar a versão antiga do cache.</span>
      </div>
      <button type="button" class="btn btn-sm btn-primary" (click)="reloadApplication()">
        Atualizar agora
      </button>
    </div>

    <div *ngIf="loadingReleases" class="release-state text-muted">
      Carregando novidades...
    </div>

    <div *ngIf="releasesUnavailable" class="release-state text-muted">
      Não foi possível carregar as novidades agora.
    </div>

    <div *ngIf="!loadingReleases && !releasesUnavailable && !releases.length" class="release-state text-muted">
      Nenhuma novidade publicada.
    </div>

    <article *ngFor="let release of releases; let last = last" class="release-item">
      <div class="release-timeline" aria-hidden="true">
        <span class="release-dot"></span>
        <span class="release-line" *ngIf="!last"></span>
      </div>
      <div class="release-content">
        <div class="release-meta">
          <strong>Versão {{ release.version }}</strong>
          <span>{{ release.publishedAt | date: 'dd/MM/yyyy' }}</span>
        </div>
        <h5>{{ release.title }}</h5>
        <ul>
          <li *ngFor="let change of release.changes">{{ change }}</li>
        </ul>
      </div>
    </article>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.close('close')">Fechar</button>
  </div>
</ng-template>
